import { Link } from 'react-router';
import styled from 'styled-components';
import { ROUTES } from '@constants/routes';

type LogoSize = 'sm' | 'md' | 'lg';

const heightMap: Record<LogoSize, number> = {
  sm: 28,
  md: 36,
  lg: 52,
};

const LogoLink = styled(Link)`
  display: inline-flex;
  align-items: center;
  text-decoration: none;
  flex-shrink: 0;
`;

const LogoImg = styled.img<{ $size: LogoSize }>`
  display: block;
  height: ${({ $size }) => heightMap[$size]}px;
  width: auto;
  object-fit: contain;
`;

interface LogoProps {
  size?: LogoSize;
  asLink?: boolean;
  className?: string;
  /**
   * inverse: aplica filtro para deixar o texto branco em fundos escuros.
   * Como a logo já tem fundo transparente e texto navy, em fundos escuros
   * usamos brightness(0) invert(1) para virar branco.
   */
  inverse?: boolean;
  variant?: 'default' | 'inverse' | 'minimal';
  animated?: boolean;
}

export function Logo({
  size = 'md',
  asLink = true,
  className,
  inverse = false,
  variant,
}: LogoProps) {
  const shouldInvert = inverse || variant === 'inverse';

  const img = (
    <LogoImg
      src="/LogoTeia.png"
      alt="Teia de Eventos"
      $size={size}
      style={shouldInvert ? { filter: 'brightness(0) invert(1)' } : undefined}
    />
  );

  if (!asLink) {
    return <div className={className}>{img}</div>;
  }

  return (
    <LogoLink to={ROUTES.home} className={className} aria-label="Teia de Eventos — Página inicial">
      {img}
    </LogoLink>
  );
}
